import {utilHelper} from "../../_helpers";

const relativeUrl = '/api/categoryModule'

export const categoryModuleService = {
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    search,
};

function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST',  { data, showAlert : false });
}


function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data });
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data });
}

function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE', {})
}